import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './MarketerProductRemoveCell.css';

const BLOCK = 'marketer-product-remove-cell';

export interface MarketerProductRemoveCellProps {
    removeMarketerProduct: () => void;
}

export const MarketerProductRemoveCell = React.memo(function(props: MarketerProductRemoveCellProps) {
    return (
        <ButtonDecorator theme={'clear'} cls={Bem.cls(BLOCK)} onClick={props.removeMarketerProduct}>
            <Shape2 icon={Shape2Icon.close} width={15} height={15} />
        </ButtonDecorator>
    );
});
